import React from 'react';
import { useTranslation } from 'react-i18next';

import Grid from '@material-ui/core/Grid';

import P from 'apps/Pdf/components/common/P';
import useGeneralStyles from 'apps/Pdf/styles/general';
import { HeaderData } from 'apps/Pdf/templates/Interfaces';
import { nicerZipInAddress } from 'apps/Pdf/helpers/helpers';

interface Props {
  data: HeaderData;
  plan?: boolean;
  children?: React.ReactNode;
  omitAdvisor?: boolean;
}

const BasicData = (props: Props) => {
  const style = useGeneralStyles();
  const { data, plan, children } = props;
  const { t } = useTranslation();

  return (
    <>
      <div className={`${style.twoColumns} ${style.lines}`}>
        <Grid container>
          <Grid item xs={4}>
            Zákazník:
          </Grid>
          <Grid item xs={8} className={`${style.bold} ${style.value}`}>
            {data.client.companyName ? (
              <>{data.client.companyName}</>
            ) : (
              <>
                {data.client.firstname} {data.client.lastname}
              </>
            )}
          </Grid>
          <Grid item xs={4}>
            Adresa:
          </Grid>
          <Grid item xs={8} className={style.value}>
            {nicerZipInAddress(data.client.permanentAddressCompact)}
            {data.client.permanentAddressCompact && data.client.permanentAddressCompact !== '' && (
              <>, {t(`country_${data.client.permanentAddress.country}`)}</>
            )}
          </Grid>

          {data.client.companyName ? (
            <Grid item xs={4}>
              IČO:
            </Grid>
          ) : (
            data.client.foreignIdType && (
              <Grid item xs={4}>
                {t(`general_personalId_${data.client.foreignIdType}`)}
              </Grid>
            )
          )}
          {data.client.identificationNumber && (
            <Grid item xs={8} className={style.value}>
              {data.client.identificationNumber}
            </Grid>
          )}
          {data.accountTitle && (
            <>
              <Grid item xs={4}>
                Název účtu:
              </Grid>
              <Grid item xs={8} className={style.value}>
                {data.accountTitle}
              </Grid>
            </>
          )}
        </Grid>

        {data.advisor && !props.omitAdvisor && (
          <Grid container>
            <Grid item xs={4}>
              Poradce:
            </Grid>
            <Grid item xs={8} className={style.value}>
              {data.advisor.firstname} {data.advisor.lastname}
            </Grid>
            <Grid item xs={4}>
              Společnost (IZ):
            </Grid>
            <Grid item xs={8} className={style.value}>
              {data.intermediaryCompany.companyName}
            </Grid>
            <Grid item xs={4}>
              Telefon:
            </Grid>
            <Grid item xs={8} className={style.value}>
              {data.advisor.contacts.phone}
            </Grid>
            <Grid item xs={4}>
              Email:
            </Grid>
            <Grid item xs={8} className={style.value}>
              {data.advisor.contacts.email}
            </Grid>
          </Grid>
        )}
      </div>

      {children}

      {data.advisor && !props.omitAdvisor && (
        <P className={`supplement${plan ? ' tighter' : ''}`}>
          {(data.advisor.role === 'PARTNER' || data.advisor.role === 'SUBSIDIARY') &&
            `Poradce je vázaným zástupcem investičního zprostředkovatele, společnosti `}
          {data.advisor.role === 'DEPUTY' &&
            `Poradce jedná za společnost ${data.partnerCompany.companyName}, IČO: ${data.partnerCompany.companyNumber}, která je vázaným zástupcem investičního zprostředkovatele, společnosti `}
          {data.advisor.role === 'DIRECT' && `Poradce jedná za investičního zprostředkovatele, společnost `}
          {data.intermediaryCompany.companyName}, IČO&nbsp;{data.intermediaryCompany.companyNumber}
          {data.signedVia === 'BT' &&
            `, sídlo: ${data.intermediaryCompany.headquarters}. Společnost ${data.intermediaryCompany.regStatement}`}
        </P>
      )}
    </>
  );
};

export default BasicData;
